var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "soap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 3,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.348,21.536a8.5,8.5,0,1,0-14.317-9.1A5,5,0,0,0,29.923,19.9",
    "data-cap": "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.807,27.722l-5.992,2.91A5,5,0,0,0,5,35.13v7.114a5,5,0,0,0,2.33,4.228l14.318,9.042a5,5,0,0,0,4.854.271L56.185,41.368A5,5,0,0,0,59,36.87V29.756a5,5,0,0,0-2.33-4.228L42.352,16.486a5,5,0,0,0-4.854-.271L22.732,23.388",
    "data-cap": "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,35.789l10.648,6.725a5,5,0,0,0,4.854.271L53,29.914"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 25,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 8.5,
    r: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoap);
export default __webpack_public_path__ + "static/media/soap.bcac7455c76eb5190ef2b876729579ca.svg";
export { ForwardRef as ReactComponent };